<template>
    <div v-loading="tableLoading">
        <el-row>
            <el-col :span="24" style="text-align: right;">
                <el-select v-model="selectValue" placeholder="请选择" style="width: 110px;">
                    <el-option value="1" label="硬件序列号"></el-option>
                    <el-option value="2" label="nid"></el-option>
                    <el-option value="3" label="mac地址"></el-option>
                    <el-option value="4" label="导入日期"></el-option>
                </el-select>
                <el-input type="text" style="width:255px;margin-left: 3px;" v-model="queryValue" v-if="isInput" placeholder="请输入"></el-input>
                <el-date-picker style="width: 255px;margin-left: 3px;" v-if="!isInput" v-model="time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"></el-date-picker>
                <el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">搜索</el-button>
            </el-col>
        </el-row>
        <div style="margin-top: 15px;">
            <el-table class="factory-table" ref="multipleTable" :data="tableData" style="width: 100%" element-loading-text="数据正在加载中" @selection-change="handleSelectionChange" :header-cell-style="headClass" :row-style="rowClass">
                >
                <el-table-column type="selection" width="60"></el-table-column>
                <el-table-column prop="nid" label="nid"></el-table-column>
                <el-table-column prop="hsn" label="硬件序列号"></el-table-column>
                <el-table-column prop="model" label="型号"></el-table-column>
                <el-table-column label="是否在线">
                    <template slot-scope="scope">
                        <el-row type="flex" style="margin-right: 10px;margin-left: 10px">
                            <div v-if="scope.row.online" style="background-color: limegreen;width: 10px;height:10px;border-radius: 50%"></div>
                            <div v-else style="background-color: #cd0000;width: 10px;height:10px;border-radius: 50%"></div>
                        </el-row>
                    </template>
                </el-table-column>
                <el-table-column label="运行状态">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status">
                            <i class="el-icon-sunny" style="color:orange"></i>
                        </div>
                        <div v-else>
                            <i class="el-icon-moon" style="color:blue"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="工作状态">
                    <template slot-scope="scope">
                        <div v-if="scope.row.online">
                            <span>{{scope.row.runStatus}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="shutdown" label="电源状态"></el-table-column>
                <el-table-column label="详情">
                    <template slot-scope="scope">
                        <button @click="showDetails(scope.row.nid)">详情</button>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <button @click="controlDialogVisible=true;curnid=scope.row.nid;curhsn='操作设备：'+scope.row.hsn">控制</button>
                        <button @click="setparamDialogVisible=true;curnid=scope.row.nid;curhsn='操作设备：'+scope.row.hsn">设置参数</button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background style="text-align:right;margin-top: 15px;margin-bottom: 55px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
        <el-dialog :visible.sync="detailsDialogVisible" width="70%">
            <span v-html="detailsHtml"></span>
        </el-dialog>
        <el-dialog :title="curhsn" :visible.sync="controlDialogVisible" width="500px">
            <el-button v-for="item in buttonData" type="primary" style="margin: 5px;width:100px" @click="control(item.action)" :key="item.action">{{item.label}}</el-button>
        </el-dialog>
        <el-dialog :title="curhsn" :visible.sync="setparamDialogVisible" width="550px">
            <el-row :gutter="10">
                <el-col :span="8">
                    <el-select v-model="setParamAction" placeholder="请选择">
                        <el-option v-for="item in selectParamDate" :key="item.action" :label="item.label" :value="item.action"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="12">
                    <el-input v-model="paramValue" placeholder></el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="setparam()" :loading="paramLoading">确定</el-button>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        name: 'waterPurifierMng',
        data() {
            return {
                curnid: 0,
                curhsn: '',
                selectValue: '',
                queryValue: '',
                time: [],
                tableData: [],
                detailsDialogVisible: false,
                controlDialogVisible: false,
                setparamDialogVisible: false,
                tableLoading: false,
                detailsHtml: '',
                buttonData: [{ label: "冲洗", action: 1 },
                { label: "滤芯 全清", action: 6 },
                { label: "滤芯A清零", action: 7 },
                { label: "滤芯B清零", action: 8 },
                { label: "滤芯C清零", action: 9 },
                { label: "增压泵清零", action: 27 }
                ],
                setParamAction: '',
                paramValue: '',
                paramLoading: false,
                selectParamDate: [{ label: "滤芯A通电寿命", action: 1 },
                { label: "滤芯B通电寿命", action: 2 },
                { label: "滤芯C通电寿命", action: 3 },
                { label: "滤芯A制水寿命", action: 8 },
                { label: "滤芯B制水寿命", action: 9 },
                { label: "滤芯C制水寿命", action: 10 }
                ],
                total: 0,
                currentPage: 1,
                pageSize: 10,
                multipleSelection: [],
                faultStateMap:{0:'水位故障',6:'制水故障',8:'漏水故障'},
                runStateMap:{0:'满水',1:'缺水',2:'溢水',3:'加热',4:'制冷',10:'设备开启',11:'制水',12:'冲洗',13:'童锁',14:'杀菌',15:'电源开',16:'原水箱满水',17:'原水箱缺水'},
            }
        },
        computed: {
            isInput: function() {
                if (this.selectValue != '4') {
                    this.queryValue = ''
                    return true
                } else {
                    this.time = [];
                    return false
                }
            },
        },
        mounted() {
            this.updateTable();
        },
        methods: {
            handleSelectionChange(val) {
                if (val.length > 1) {
                    //设置单选
                    this.$refs.multipleTable.clearSelection();
                    this.$refs.multipleTable.toggleRowSelection(val.pop());
                }
                this.multipleSelection = val
            },
            handleSizeChange(val) {
                this.pageSize = val
                this.updateTable()
            },
            handleCurrentChange(val) {
                this.currentPage = val
                this.updateTable()
            },
            rowClass({
                row,
                rowIndex
            }) {
                if (rowIndex % 2 == 0) {
                    return 'background:#F1F2F7;'
                } else {
                    return 'background:white;'
                }
                return ''
            },
            headClass({
                row,
                rowIndex
            }) {
                if (rowIndex == 0) {
                    return ''
                }
                return ''
            },
            getStandardDate(val) {
                var year = val.getFullYear()
                var month = val.getMonth() + 1
                var day = val.getDate()
                month = month < 10 ? '0' + month : month
                day = day < 10 ? '0' + day : day
                return year + '-' + month + '-' + day
            },
            setparam() {
                var thiz = this;
                if (thiz.setParamAction == '') {
                    thiz.$message.error("请选择待设置的项目");
                    return false;
                }
                if (thiz.paramValue == '') {
                    thiz.$message.error("值不能为空");
                    return false;
                }
                // if (thiz.setParamAction == '51' && !(thiz.paramValue == 0 || thiz.paramValue == 45 || thiz.paramValue == 88)) {
                //     thiz.$message.error("热罐温度只能设置为0，45，88");
                //     return false;
                // }
                if (thiz.setParamAction == '64' && !(thiz.paramValue == 0 || thiz.paramValue == 1)) {
                    thiz.$message.error("按键方式只能设置为0：长按键出水 1：按键开始，按键停止");
                    return false;
                }
                thiz.paramLoading = true;
                axios
                    .get(this.$store.getters.getApiValue + '/smartWaterPurify/setParam.do', {
                        params: {
                            nid: thiz.curnid,
                            action: thiz.setParamAction,
                            actionValue: thiz.paramValue,
                            sync: true
                        }
                    })
                    .then(function(response) {
                        thiz.paramLoading = false;
                        var data = response.data
                        if (data.status == '200') {
                            if (data.data === 'success') {
                                thiz.$message.success("操作成功");
                            } else {
                                thiz.$message.error("操作失败");
                            }
                        } else {
                            thiz.$message.error(data.message)
                        }
                    })
                    .catch(function(error) {
                        thiz.paramLoading = false;
                        console.log(error)
                        thiz.$message.error('系统异常!请与管理员联系!')
                    })
            },
            control(action) {
                var thiz = this;
                const loading = this.$loading({
                    lock: true,
                    text: '操作执行中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                axios
                    .get(this.$store.getters.getApiValue + '/smartWaterPurify/operate.do', {
                        params: {
                            nid: thiz.curnid,
                            action: action,
                            sync: true
                        }
                    })
                    .then(function(response) {
                        loading.close()
                        var data = response.data
                        if (data.status == '200') {
                            if (data.data === 'success') {
                                thiz.$message.success("操作成功");
                            } else {
                                thiz.$message.error("操作失败");
                            }
                        } else {
                            thiz.$message.error(data.message)
                        }
                    })
                    .catch(function(error) {
                        loading.close()
                        console.log(error)
                        thiz.$message.error('系统异常!请与管理员联系!')
                    })
            },
            showDetails(nid) {
                var thiz = this;
                axios
                    .get(this.$store.getters.getApiValue + 'admin/water-purifier/getHomeInfo.do', {
                        params: {
                            nid: nid
                        }
                    })
                    .then(function(response) {
                        var data = response.data
                        if (data.status == '200') {
                            var info = data.data.info;
                            var runtime = data.data.status;
                            var gsm = data.data.gsm;
                            var protocol=data.data.protocol;
                            var strHtml="";
                            if(protocol==3){
                                if(info!=null){
                                    strHtml += " <h3><b>设备配置信息(单位：秒)</b></h3><table><tbody>";
                                    strHtml += ("<tr><td class='infoTable'>模块类型</td><td class='valueTable'>" + info.type + "</td><td class='infoTable'>软件版本</td><td class='valueTable'>" + info.softVersion + "</td><td class='infoTable'>硬件版本</td><td class='valueTable'>" + info.hardVersion + "</td></tr><tr><tr><td class='infoTable'>统计信息上报周期</td><td class='valueTable'>" + info.statisticalInterval + "</td><td class='infoTable'>实时信息上报周期</td><td class='valueTable'>" + info.runInterval + "</td></tr><tr><td class='infoTable'>滤芯通电寿命</td><td colspan='5' class='valueTable'>" + info.filterEndTime + "</td></tr><tr><td class='infoTable'>滤芯制水寿命</td><td colspan='5' class='valueTable'>" + info.filterWaterEndTime + "</td></tr>");
                                    strHtml += " </tbody></table>";
                                }
                                if(runtime!=null){
                                    runtime.runStateDesc=thiz.bitTransform(thiz.runStateMap,runtime.runState);
                                    runtime.faultStateDesc=thiz.bitTransform(thiz.faultStateMap,runtime.faultState);
                                    strHtml += " <h3><b>设备统计信息(单位：秒)</b></h3><table><tbody>";
                                    strHtml += ("<tr><td class='infoTable'>信号强度</td><td class='valueTable'>" + runtime.csq + "</td><td class='infoTable'>设备到期时间</td><td class='valueTable'>" + runtime.endTime + "</td><td class='infoTable'>设备激活状态</td><td class='valueTable'>" + runtime.active + "</td></tr><tr><td class='infoTable'>设备累计运行时长</td><td class='valueTable'>" + runtime.totalRunTime + "</td><td class='infoTable'>增压泵累计运行时长</td><td class='valueTable'>" + runtime.totalPumpTime + "</td><td class='infoTable'>设备累计出水时长</td><td class='valueTable'>" + runtime.totalWaterTime + "</td></tr><tr><td class='infoTable'>设备累计出水量(ml)</td><td class='valueTable'>" + runtime.totalWaterVolume + "</td><td class='infoTable'>TDS</td><td class='valueTable'>" + runtime.tds + "</td><td class='infoTable'>原水模式</td><td  class='valueTable'>" + (thiz.descRawWaterMode(JSON.parse(runtime.expandShortForRuntime)[0])) + "</td></tr><tr><td class='infoTable'>滤芯通电时长</td><td colspan='5' class='valueTable'>" + runtime.filterRunTime + "</td></tr><tr><td class='infoTable'>滤芯制水时间</td><td colspan='5' class='valueTable'>" + runtime.filterWaterTime + "</td></tr><tr><td class='infoTable'>运行状态</td><td colspan='5' class='valueTable'>" + runtime.runStateDesc + "</td></tr><tr><td class='infoTable'>故障状态</td><td colspan='5' class='valueTable'>" + runtime.faultStateDesc + "</td></tr>");
                                    strHtml += " </tbody></table>";
                                }
                            }else{
                                if(info!=null){
                                    strHtml += " <h3><b>设备配置信息(单位：秒)</b></h3><table><tbody>";
                                    strHtml += ("<tr><td class='infoTable'>模块类型</td><td class='valueTable'>" + info.type + "</td><td class='infoTable'>软件版本</td><td class='valueTable'>" + info.softVersion + "</td><td class='infoTable'>硬件版本</td><td class='valueTable'>" + info.hardVersion + "</td></tr><tr><tr><td class='infoTable'>统计信息上报周期</td><td class='valueTable'>" + info.statisticalInterval + "</td><td class='infoTable'>实时信息上报周期</td><td class='valueTable'>" + info.runInterval + "</td><td class='infoTable'>TDS报警阀值</td><td class='valueTable'>" + info.tdsAlarm + "</td></tr><tr><td class='infoTable'>滤芯通电寿命</td><td colspan='5' class='valueTable'>" + info.filterEndTimes + "</td></tr><tr><td class='infoTable'>滤芯制水寿命</td><td colspan='5' class='valueTable'>" + info.filterProductEndTimes + "</td></tr>");
                                    strHtml += " </tbody></table>";
                                }
                                if(runtime!=null){
                                    strHtml += " <h3><b>设备统计信息(单位：秒)</b></h3><table><tbody>";
                                    strHtml += ("<tr><td class='infoTable'>信号强度</td><td class='valueTable'>" + "强" + "</td><td class='infoTable'>设备到期时间</td><td class='valueTable'>" + runtime.endTime + "</td><td class='infoTable'>设备激活时间</td><td class='valueTable'>" + runtime.activeTime + "</td></tr><tr><td class='infoTable'>设备开机总次数</td><td class='valueTable'>" + runtime.upCount + "</td><td class='infoTable'>设备累计运行时长</td><td class='valueTable'>" + runtime.totalUpTime + "</td><td class='infoTable'>设备本次开机时长</td><td class='valueTable'>" + runtime.curUpTime + "</td></tr><tr><td class='infoTable'>TDS</td><td class='valueTable'>" + runtime.tdses + "</td><td class='infoTable'>设备累计出水时长</td><td class='valueTable'>" + runtime.totalVolumeTime + "</td><td class='infoTable'>增压泵运行时长</td><td class='valueTable'>" + runtime.totalPumpTime + "</td></tr><tr><td class='infoTable'>滤芯启动时间戳</td><td colspan='5' class='valueTable'>" + runtime.filterActiveTimes + "</td></tr><tr><td class='infoTable'>滤芯通电时长</td><td colspan='5' class='valueTable'>" + runtime.filterUpTimes + "</td></tr><tr><td class='infoTable'>滤芯制水时间</td><td colspan='5' class='valueTable'>" + runtime.filterProductTimes + "</td></tr>");
                                    strHtml += " </tbody></table>";
                                }
                            }
                            
                            if(gsm!=null){
                                var sta = "";
                                if (gsm.csq <= 8) {
                                    sta = "极弱";
                                } else if (8 < gsm.csq && gsm.csq <= 15) {
                                    sta = "弱";
                                } else if (15 < gsm.csq && gsm.csq <= 24) {
                                    sta = "中";
                                } else {
                                    sta = "强";
                                }
                                strHtml += " <h3><b>GSM信息</b></h3><table><tbody>";
                                strHtml += ("<tr><td class='infoTable'>GSM类型</td><td class='valueTable'>" + gsm.type + "</td><td class='infoTable'>信号强度</td><td class='valueTable'>" + sta + "</td><td class='infoTable'>gsm版本</td><td class='valueTable'>" + gsm.version + "</td></tr><tr> <td class='infoTable'>地区区域码</td><td class='valueTable'>" + gsm.lac + "</td><td class='infoTable'>移动基站码</td><td class='valueTable'>" + gsm.ci + "</td><td class='infoTable'>经度</td><td class='valueTable'>" + gsm.longitude + "</td></tr><tr><td class='infoTable'>纬度</td><td class='valueTable'>" + gsm.latitude + "</td><td class='infoTable'>IMEI</td><td class='valueTable'>" + gsm.imei + "</td><td class='infoTable'>CCID</td><td class='valueTable'>" + gsm.ccid + "</td></tr><tr><td class='infoTable'>地址</td><td colspan='5' class='valueTable'>" + gsm.address + "</td></tr>");
                                strHtml += " </tbody></table>";
                            }
                            thiz.detailsHtml = strHtml;
                            thiz.detailsDialogVisible = true;
                        } else {
                            thiz.$message.error(data.message)
                        }
                    })
                    .catch(function(error) {
                        console.log(error)
                        thiz.$message.error('系统异常!请与管理员联系!')
                    })
            },
            bitTransform(map,value){
                let desc="";
                for(let i=0;i<parseInt(value).toString(2).length;i++){
                    if(((value>>i)& 0x01)==1){
                        if(map[i]){
                            desc+=map[i]+" "
                        }
                    }
                }
                return desc;
            },
            descRawWaterMode(value){
                var desc="";
                if(value){
                    if(value==88){
                        desc='自来水';
                    }else if(value==99){
                        desc='水箱';
                    }
                }
                return desc;
            },
            updateTable() {
                this.tableLoading = true;
                var thiz = this
                var params = {
                    pageId: this.currentPage,
                    size: this.pageSize,
                    ntId: 1030
                }
                if (this.selectValue != '') {
                    if (this.selectValue == '1' && this.queryValue != '') {
                        params.hsn = this.queryValue
                    } else if (this.selectValue == '2' && this.queryValue != '') {
                        params.nid = this.queryValue
                    } else if (this.selectValue == '3' && this.queryValue != '') {
                        params.mac = this.queryValue
                    } else if (this.selectValue == '4') {
                        if (this.time != null && this.time.length > 0) {
                            params.begin = this.getStandardDate(this.time[0])
                            params.end = this.getStandardDate(this.time[1])
                        }
                    }
                }
                axios
                    .get(this.$store.getters.getApiValue + 'admin/water-purifier/list.do', {
                        params: params
                    })
                    .then(function(response) {
                        var data = response.data
                        if (data.status == '200') {
                            thiz.total = data.totalCount
                            thiz.tableData = data.data
                        } else {
                            thiz.$message.error(data.message)
                        }
                    })
                    .catch(function(error) {
                        console.log(error)
                        thiz.$message.error('系统异常!请与管理员联系!')
                    })
                    .finally(() => {
                        this.tableLoading = false
                    })
            }
        }
    }
</script>

<style>
    .valueTable {
        width: 180px;
        border-top: 1px solid #e7eaec;
        padding: 5px;
    }

    .infoTable {
        color: #000000;
        width: 120px;
        font-size: 14px;
        border-top: 1px solid #e7eaec;
    }
</style>

<style scoped>
    .factory-table {
        font-size: 12px;
    }
</style>